<div [class]="model.renderCssRoot" #contentElement>
  <sv-ng-dropdown [model]="model"></sv-ng-dropdown>
  <div *ngIf="model.isOtherSelected" [class]="model.getCommentAreaCss(true)" [question]="model" sv-ng-comment-other></div>
</div>